import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';
import device from '../../config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }

  }


  .refera-form {
    height: 1600px !important;
    margin-top: 30px;
  }

  .CustomFormRequestRepair {
    width: 70%;
    margin: 0 auto;
    margin-top: 30px;
    .MuiGrid-item {
      padding-bottom: 0px;
      padding-top: 0px;
      label {
        width: 100%;
        display: block;
        font-weight: bold;
      }
      input, textarea {
        width: 100%;
        display: block;
        border: 1px solid var(--gray);
        border-radius: 10px;
        height: 50px;
        padding: 0px 35px 0px 15px;
        margin: 10px 0 10px 0;
        margin-top:0px;
      }
    }
    button[type='submit'] {
      background: var(--yellowDark);
      padding: 10px 25px;
      box-sizing: border - box;
      box-shadow: 2px 2px 0 rgba(12, 13, 14, 0.15);
      transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
      border-radius: 15px;
      display:block;
      margin: 0 auto;
      margin-top: 10px;

      &:hover {
        box-shadow: 1px 1px 0 rgba(12, 13, 14, 0.15);
        background: ${darken(0.04, '#f7c325')};
      }

      @media ${device.mobileMinTabMax} {
        padding: 0 15px;
        margin: 5px;
      }
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

